const navigation = {
  sections: {
    contentOperations: "Работа с контентом",
    personalSetup: "Личные настройки",
    systemAdministration: "Администрирование системы",
  },
  items: {
    dashboard: "Панель управления",
    contentInbox: "Мой контент",
    promotions: "Продвижение",
    publishingHistory: "История публикаций",
    sources: "Мои источники",
    filters: "Мои фильтры",
    destinations: "Мои каналы назначения",
    aiConfiguration: "Мои настройки ИИ",
    teamAccess: "Команда и доступ",
    systemSettings: "Системные настройки",
  },
  titles: {
    dashboard: "Панель управления",
    feed: "Мой контент",
    history: "История публикаций",
    promotion: "Продвижение",
    channels: "Каналы-источники",
    filters: "Фильтры контента",
    destination: "Мои каналы назначения",
    ai: "Настройки ИИ",
    team: "Команда и доступ",
    database: "Системные настройки",
  },
  mobile: {
    home: "Главная",
    inbox: "Контент",
    promotions: "Продвижение",
    more: "Ещё",
    moreDescription: "История и настройки рабочего пространства",
  },
  account: {
    administrator: "Администратор",
    systemOwner: "Владелец системы",
    personalWorkspace: "Личное рабочее пространство",
    contentAdmin: "Администратор контента",
    owner: "Владелец",
    admin: "Администратор",
  },
  status: {
    workspace: "Операции с Telegram-контентом на базе ИИ",
    publishingSetupRequired: "Требуется настройка публикации",
    publishingTargetsReady_one: "{{count}} канал назначения готов",
    publishingTargetsReady_few: "{{count}} канала назначения готовы",
    publishingTargetsReady_many: "{{count}} каналов назначения готовы",
    publishingTargetsReady_other: "{{count}} канала назначения готовы",
    secureWorkspace: "Защищённое рабочее пространство",
    targetsReady_one: "{{count}} канал готов",
    targetsReady_few: "{{count}} канала готовы",
    targetsReady_many: "{{count}} каналов готовы",
    targetsReady_other: "{{count}} канала готовы",
  },
  accessibility: {
    openDashboard: "Открыть панель управления TGReposter",
    closeSidebar: "Закрыть боковую панель",
    openSidebar: "Открыть боковую панель",
    primaryNavigation: "Основная навигация",
    signOut: "Выйти",
    closeMoreNavigation: "Закрыть дополнительную навигацию",
    mobileNavigation: "Мобильная навигация",
    openPromotionCenter: "Открыть центр продвижения",
  },
} as const;

export default navigation;
